import SwitchItem from "./SwitchItem";

function SwitcherLessons({course, handler, activeLesson}) {
    return (
        <div className="switcher">
            <h3>Уроки</h3>
            <ul>
                {course.map(lesson =>
                    <SwitchItem
                        key={lesson.id}
                        id={lesson.id}
                        isActive={lesson.id === activeLesson.id}
                        handler={() => handler(lesson)}
                    />
                )}
            </ul>
        </div>
    )
}

export default SwitcherLessons;